<div class="alert-feedback-container" (click)="onNestedClick($event)">
  <div class="alert-feedback-message">
    {{'t.alertFeedbackPrompt' | translate}}
  </div>
  <div class="alert-feedback-thumbs-group">
    <img *ngIf="this.model.currentFeedback$() !== 'POSITIVE'" [src]="thumb_up()" (click)="selectFeedback('POSITIVE')" />
    <img *ngIf="this.model.currentFeedback$() === 'POSITIVE'" [src]= "thumb_up_selected()" />
    <img *ngIf="this.model.currentFeedback$() !== 'NEGATIVE'" [src]= "thumb_down()" (click)="selectFeedback('NEGATIVE')" />
    <img *ngIf="this.model.currentFeedback$() === 'NEGATIVE'" [src]= "thumb_down_selected()" />
  </div>
</div>
